<template>
  <div>
    <el-row>
      <el-col style="margin-top:20px;">
        <span style="color:#F56C6C">您选择的订单中含有未分类的产品，请对以下产品分类后查看采买单</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="margin-top:20px">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="NAME" label="名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="addProduct(scope.row)">匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="匹配产品" center :visible.sync="addFormVisible" width="700px">
          <el-form :model="addForm" ref="addForm" size="small" class="el-form--label-justify">
            <el-col :span="12">
              <el-form-item label="产品分类：" :label-width="formLabelWidth">
                <el-select v-model="addForm.CATALOG_ID" style="width:80%">
                  <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="体积：" :label-width="formLabelWidth">
                <el-input v-model="addForm.VOLUME" style="width:80%"></el-input>
              </el-form-item>
              <el-form-item label="温区：" :label-width="formLabelWidth">
                <label slot="label">温&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区：</label>
                <el-select v-model="addForm.WZ_TYPE_ID" style="width:80%">
                  <el-option v-for="item in WZ_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出库方式：" :label-width="formLabelWidth">
                <el-select v-model="addForm.OW_TYPE" style="width:80%">
                  <el-option v-for="item in wayOut" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="安全库存：" :label-width="formLabelWidth">
                <el-input v-model="addForm.SAFETY_STOCK" style="width:80%"></el-input>
              </el-form-item>
              <el-form-item label="销项税率：" :label-width="formLabelWidth">
                <el-input v-model="addForm.OUTPUT_VAT" style="width:70%"></el-input> <span>%</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="重量：" :label-width="formLabelWidth">
                <el-input v-model="addForm.WEIGHT" style="width:80%"></el-input>
              </el-form-item>
              <el-form-item label="预警期：" :label-width="formLabelWidth">
                <label slot="label">预&nbsp;&nbsp;警&nbsp;&nbsp;期：</label>
                <el-input v-model="addForm.WARNING_PERIOD" style="width:50%"></el-input>
                <el-select v-model="addForm.WP_TIME_TYPE" style="width:30%">
                  <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="保质期：" :label-width="formLabelWidth">
                <label slot="label">保&nbsp;&nbsp;质&nbsp;&nbsp;期：</label>
                <el-input v-model="addForm.QGP" style="width:50%"></el-input>
                <el-select v-model="addForm.QGP_TIME_TYPE" style="width:30%">
                  <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下架期：" :label-width="formLabelWidth">
                <label slot="label">下&nbsp;&nbsp;架&nbsp;&nbsp;期：</label>
                <el-input v-model="addForm.PULL_OFF_PERIOD" style="width:50%"></el-input>
                <el-select v-model="addForm.PO_TIME_TYPE" style="width:30%">
                  <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="进项税率：" :label-width="formLabelWidth">
                <el-input v-model="addForm.INPUT_VAT" style="width:70%"></el-input> <span>%</span>
              </el-form-item>
              <el-form-item label="库位编码：" :label-width="formLabelWidth">
                <el-select v-model="addForm.LOCATION_CODE" style="width:80%">
                  <el-option v-for="item in positionLi" :key="item.ID" :label="item.CODE" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import { queryWQ, getClassFun, addUseSKU } from '@/assets/api/skuManage';
import { queryPosition } from '@/assets/api/warehouseManager';

export default {
  data() {
    return {
      currentOrderFlag: sessionStorage.getItem('currentOrderFlag'),
      tableData: [],
      addForm: {
        WZ_TYPE_ID: 0,
        OUTPUT_VAT: 0,
        OW_TYPE: 0,
        WARNING_PERIOD: 0,
        INPUT_VAT: 0,
        QGP: 0,
        PULL_OFF_PERIOD: 0,
        QGP_TIME_TYPE: 1,
        PO_TIME_TYPE: 1,
        WP_TIME_TYPE: 1,
        LOCATION_CODE: 0,
        SAFETY_STOCK: 0,
        VOLUME: 0,
        WEIGHT: 0,
      },
      catalogList: [],
      addFormVisible: false,
      kinds: [],
      formLabelWidth: '100px',
      positionLi: [],
      date_list_qgp: [
        {
          ID: 4,
          NAME: '日',
        },
      ],
      OWLists: [
        {
          ID: '1',
          NAME: 'MTO',
        },
        {
          ID: '2',
          NAME: 'MTS',
        },
        {
          ID: '3',
          NAME: 'DS',
        },
      ],
      WZ_list: [],
      wayOut: [
        {
          ID: 1,
          NAME: 'MTO',
        }, {
          ID: 2,
          NAME: 'MTS',
        }, {
          ID: 3,
          NAME: 'DS',
        },
      ],
      date_list: [
        {
          ID: 1,
          NAME: '年',
        }, {
          ID: 2,
          NAME: '季',
        }, {
          ID: 3,
          NAME: '月',
        }, {
          ID: 4,
          NAME: '日',
        }, {
          ID: 5,
          NAME: '时',
        },
      ],
    };
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: sessionStorage.getItem('sendDay'),
        CATALOG_ID: Number(sessionStorage.getItem('kindId')),
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result;
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取温区
    queryWZ() {
      queryWQ().then((result) => {
        this.WZ_list = result;
      }).catch((error) => {
      });
    },
    queryCatalog() {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addProduct(row) {
      this.addFormVisible = true;
      this.addForm = row;
    },
    submitAdd() {
      if (!this.addForm.CATALOG_ID) {
        this.$message.show({ text: '请选择产品分类', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ALIAS_NAME: this.addForm.NAME,
            GYS_ID: sessionStorage.getItem('tcId'),
            PRODUCT_CODE: this.addForm.PRODUCT_CODE,
            CATALOG_ID: this.addForm.CATALOG_ID,
            OW_TYPE: this.addForm.OW_TYPE ? this.addForm.OW_TYPE : 0,
            SAFETY_STOCK: this.addForm.SAFETY_STOCK ? this.addForm.SAFETY_STOCK : 0,
            WZ_TYPE_ID: this.addForm.WZ_TYPE_ID ? this.addForm.WZ_TYPE_ID : 0,
            QGP: this.addForm.QGP ? this.addForm.QGP : 0,
            QGP_TIME_TYPE: this.addForm.QGP_TIME_TYPE ? this.addForm.QGP_TIME_TYPE : 0,
            WARNING_PERIOD: Number(this.addForm.WARNING_PERIOD) ? this.addForm.WARNING_PERIOD : 0,
            WP_TIME_TYPE: this.addForm.WP_TIME_TYPE ? this.addForm.WP_TIME_TYPE : 0,
            PULL_OFF_PERIOD: this.addForm.PULL_OFF_PERIOD ? this.addForm.PULL_OFF_PERIOD : 0,
            PO_TIME_TYPE: this.addForm.PO_TIME_TYPE ? this.addForm.PO_TIME_TYPE : 0,
            INPUT_VAT: this.addForm.INPUT_VAT ? this.addForm.INPUT_VAT : 0,
            OUTPUT_VAT: this.addForm.OUTPUT_VAT ? this.addForm.OUTPUT_VAT : 0,
            LOCATION_CODE: this.addForm.LOCATION_CODE,
            DEFAULT_LOCATION_ID: Number(this.addForm.LOCATION_CODE) ? Number(this.addForm.LOCATION_CODE) : 0,
            VOLUME: Number(this.addForm.VOLUME) ? Number(this.addForm.VOLUME) : 0,
            WEIGHT: Number(this.addForm.WEIGHT) ? Number(this.addForm.WEIGHT) : 0,
          };
          addUseSKU(params).then((result) => {
            this.$message.show({ text: '匹配成功', type: 'success' });
            this.addFormVisible = false;
            this.addForm = {};
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
      this.addForm = {};
    },
  },
  created() {
    this.queryTable();
    this.queryCatalog();
    this.queryWZ();
    queryPosition().then((res) => {
      this.positionLi = res;
    }).catch((error) => {
      this.$message.show({ text: error, type: 'error' });
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sendDocument/PurchaseMatchProduct.vue